import { uuid } from "short-uuid";
import { mapColDefToColumnOptionState } from "../utils";
import { getTenorOptionFromLabel } from "components/widgets/chart/base/utils";
const sortColumnTemplate = (payload) => {
    const result = { ...payload, columnsTemplate: { ...payload.columnsTemplate, columns: [] } };
    payload.columnsTemplate?.columns.forEach((col, index) => {
        (result.columnsTemplate?.columns).push({ ...col, sequenceNumber: index });
    });
    return result;
};
const processChildColumns = (children, columnsOptions, datapointParams, parentUid, componentPropsPatchers) => {
    children.forEach((c, childIndex) => {
        const child = { ...c, uid: c?.field ?? uuid() };
        columnsOptions.push({
            ...mapColDefToColumnOptionState(child, datapointParams, childIndex, undefined, true, componentPropsPatchers),
            groupId: parentUid
        });
    });
};
const processColumn = (col, index, columnsOptions, groupingOptionsDatapoints, datapointParams, dataSelectProps, componentPropsPatchers) => {
    const column = { ...col, uid: col?.field ?? uuid() };
    const option = mapColDefToColumnOptionState(column, datapointParams, index, dataSelectProps, column.children?.length, componentPropsPatchers);
    columnsOptions.push(option);
    if (column.enableRowGroup) {
        const measure = (datapointParams?.measures ?? [])?.find((m) => m.name === col.field);
        groupingOptionsDatapoints.push({
            customDatapoint: measure?.customDatapoint,
            id: column.uid,
            name: option.name,
            standardDatapoint: measure?.standardDatapoint
        });
    }
    if (column.children) {
        processChildColumns(column.children, columnsOptions, datapointParams, column.uid, componentPropsPatchers);
    }
};
const populateColumnsFromTemplate = (state, payload) => {
    if (!state.editor.settings?.data?.columns) {
        return;
    }
    state.editor.settings.groupingOptionsDatapoints = [];
    const { columnsTemplate, datapointParams } = payload?.userSettings?.gridSwitch
        ? { columnsTemplate: payload?.gridSwitcher?.columnsTemplate, datapointParams: payload?.gridSwitcher?.datapointParams }
        : { columnsTemplate: payload.columnsTemplate, datapointParams: payload.datapointParams }, dataSelectProps = payload?.dataSelectProps;
    if (state.editor.settings.data.columns.options?.length) {
        state.editor.settings.data.columns.options = [];
    }
    const columnsOptions = state.editor.settings.data.columns.options ?? [];
    const groupingDatapoints = state.editor.settings?.groupingOptionsDatapoints ?? [];
    columnsTemplate?.columns?.forEach((col, index) => {
        processColumn(col, index, columnsOptions, groupingDatapoints, datapointParams?.[0], dataSelectProps, payload.componentPropsPatchers);
    });
};
export const setWorkshopComponentPropsReducer = (state, action) => {
    if (!action.payload) {
        return;
    }
    Object.assign(state.editor, action.payload);
    state.editor.preview.widget = { ...state.editor.preview.widget,
        componentProps: { ...sortColumnTemplate(action.payload),
            defaultTenor: getTenorOptionFromLabel(action.payload.subtitle) } };
    if (!state.editor.settings) {
        state.editor.settings = {};
    }
    if (!state.editor.settings.widgetFilterValues) {
        state.editor.settings.widgetFilterValues = action.payload.defaultFilters ?? {};
    }
    populateColumnsFromTemplate(state, action.payload);
};
